import { render, staticRenderFns } from "./component3.vue?vue&type=template&id=4970a579&scoped=true&"
import script from "./component3.vue?vue&type=script&lang=js&"
export * from "./component3.vue?vue&type=script&lang=js&"
import style0 from "./component3.vue?vue&type=style&index=0&id=4970a579&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4970a579",
  null
  
)

export default component.exports